const isInteger = (value) => /[0-9]+/.test(value);

export default isInteger;
